export interface Article {
  slug: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  categoryName: string;
  tags: string[];
  imageSeq: string;
  authorName: string;
  authorAvatar: string;
  publishDate: string;
  viewCount: number;
  commentCount: number;
  isHot: boolean;
  isTop: boolean;
  heatIndex: number;
  readTime: number;
}

export const articles: Article[] = [
  {
    slug: 'dingliu-shenye-huiying',
    title: '某顶流深夜发文回应近期争议：清者自清，法律程序已启动',
    summary: '近日陷入舆论漩涡的某顶流艺人于凌晨三点通过工作室发布长文，正面回应近期多项指控，表示将通过法律途径维护权益，引发全网热议。',
    content: '<p>近日，某顶流艺人在凌晨三点通过工作室官方微博发布了一篇长达两千字的声明文章，正面回应了近期网络上关于其个人的多项指控。声明中，该艺人表示"清者自清"，并宣布已经委托国内知名律师事务所正式启动法律程序，将对恶意造谣者追究法律责任。</p><p>这篇深夜声明迅速登上微博热搜榜首，阅读量在短短一小时内突破三亿。声明中详细列举了近期网络上流传的五项主要指控，并逐一进行了驳斥。该艺人强调，部分截图和所谓的"证据"属于恶意拼接和断章取义，严重损害了其个人名誉。</p><p>业内人士分析认为，该艺人选择在凌晨发布声明，一方面是为了避开白天信息洪流，确保声明能够被完整传播；另一方面也体现了其团队对此次公关危机的重视程度。多家主流媒体随后跟进报道，舆论场呈现出两极分化的态势。</p><p>目前，该艺人的多位圈内好友已经转发支持，而涉事律师事务所在接受采访时表示，已经完成证据保全工作，不日将正式向法院提起诉讼。这场娱乐圈风暴究竟会如何收场，吃瓜群众拭目以待。</p>',
    category: 'wanghong-baoliao',
    categoryName: '网红爆料',
    tags: ['顶流塌房', '深夜回应', '律师函警告'],
    imageSeq: 'article-01',
    authorName: '吃瓜编辑组',
    authorAvatar: '',
    publishDate: '2026-07-07',
    viewCount: 12856320,
    commentCount: 89520,
    isHot: true,
    isTop: true,
    heatIndex: 9856321,
    readTime: 8,
  },
  {
    slug: 'zhibo-daihuo-fanche',
    title: '知名带货主播直播翻车现场：产品功效遭质疑，品牌方紧急回应',
    summary: '昨晚某千万粉丝级带货主播在直播间推销某护肤品时，被网友实锤产品功效宣传与实际情况严重不符，直播间弹幕瞬间炸锅，品牌方连夜发布声明。',
    content: '<p>昨晚，某拥有超过三千万粉丝的头部带货主播在直播间推销一款高价护肤品时，遭遇了职业生涯中最严重的一次"翻车"事故。当主播激情澎湃地宣称该产品"七天见效、二十八天焕肤"时，直播间弹幕突然被大量网友的质疑刷屏。</p><p>有细心的网友当场截图对比，发现该产品的成分表与主播宣传的功效严重不符，更有药学专业的网友指出，其宣称的"活性成分"含量极低，根本无法达到宣传中的护肤效果。弹幕瞬间炸锅，"退钱""虚假宣传""骗子"等词汇刷满屏幕。</p><p>面对突如其来的质疑，主播一度语塞，随后试图以"口误"为由搪塞过去，但网友们并不买账。事件持续发酵，当晚相关话题就冲上了多个社交平台的热搜榜。品牌方在凌晨紧急发布声明，表示将对产品宣传内容进行全面核查，并向消费者致歉。</p><p>目前，已有多个消费者维权群建立，部分购买者要求"退一赔三"。市场监管部门也对此事表示关注。这次事件再次引发了对直播带货行业规范化的讨论。</p>',
    category: 'chigua-qianxian',
    categoryName: '吃瓜前线',
    tags: ['带货翻车', '直播争议', '品牌解约'],
    imageSeq: 'article-02',
    authorName: '一线记者小王',
    authorAvatar: '',
    publishDate: '2026-07-06',
    viewCount: 9872300,
    commentCount: 67890,
    isHot: true,
    isTop: false,
    heatIndex: 8754120,
    readTime: 6,
  },
  {
    slug: 'lianqing-puguang-jingxi',
    title: '惊爆！某当红小生与圈外女友恋情曝光，两人同居已超半年',
    summary: '据知情人士透露，某当红小生与圈外白富美已秘密交往长达一年，两人被拍到多次出入同一高档小区，疑似已经同居。粉丝直呼"房子塌了"。',
    content: '<p>据知情人士向本网独家爆料，某当红小生与一位圈外白富美已经秘密交往超过一年，两人近日被拍到多次出入北京某高档住宅小区，疑似已经进入同居阶段。消息一出，该艺人的粉丝群体瞬间炸锅，"房子塌了"的话题迅速登上热搜。</p><p>据悉，女方为某知名投资机构高管的独生女，毕业于海外名校，目前在国内从事艺术策展工作。两人经共同朋友介绍认识，交往期间一直保持低调。知情人士透露，两人感情稳定，已经见过双方家长。</p><p>该艺人此前在多个采访中均表示"目前单身，以事业为重"，此次恋情曝光让不少粉丝感到被欺骗。但也有理智粉丝表示，艺人也有追求个人幸福的权利，呼吁大家理性看待。</p><p>截至目前，该艺人及其工作室尚未对此事做出回应。娱乐记者已蹲守在该艺人住所和公司附近，后续进展将持续关注。</p>',
    category: 'yule-quan',
    categoryName: '娱乐圈',
    tags: ['恋情曝光', '热搜第一'],
    imageSeq: 'article-03',
    authorName: '娱乐挖机组',
    authorAvatar: '',
    publishDate: '2026-07-06',
    viewCount: 11234560,
    commentCount: 76540,
    isHot: true,
    isTop: false,
    heatIndex: 7652300,
    readTime: 7,
  },
  {
    slug: 'pp-liao-jiage-zoushi',
    title: 'PP料今日最新价格：市场震荡上行，业内人士分析后市走向',
    summary: '今日PP料市场迎来新一轮价格调整，各主要产区报价普遍上涨50-100元/吨。资深分析师指出，受原材料成本上升影响，短期内PP料价格仍将保持高位运行。',
    content: '<p>今日PP料市场迎来新一轮价格调整，各主要产区报价普遍上涨50-100元/吨。据本网监测数据显示，华东地区PP拉丝料主流报价在8650-8850元/吨，华南地区报价在8700-8900元/吨，华北地区报价在8550-8750元/吨。</p><p>资深行业分析师老张指出，本轮价格上涨主要受三方面因素驱动：一是上游丙烯单体价格持续走高，成本端支撑强劲；二是下游塑编、注塑等行业进入传统需求旺季，采购量明显增加；三是部分装置进入检修期，市场供应有所收紧。</p><p>从后市来看，短期内PP料价格仍将保持高位运行。建议下游企业合理安排采购节奏，避免在高位大量囤货。同时需密切关注国际原油价格走势和国内宏观经济政策变化。</p><p>此外，进口PP料方面，受人民币汇率波动影响，近期进口货源价格优势有所减弱，这也在一定程度上支撑了国产PP料的价格。整体来看，PP料市场短期内将维持震荡偏强格局。</p>',
    category: 'pp-liao',
    categoryName: 'PP料专区',
    tags: ['PP料今日最新价格'],
    imageSeq: 'article-04',
    authorName: '行情分析师老张',
    authorAvatar: '',
    publishDate: '2026-07-07',
    viewCount: 6541890,
    commentCount: 12340,
    isHot: false,
    isTop: false,
    heatIndex: 6541890,
    readTime: 5,
  },
  {
    slug: 'zongyi-luzhi-shiba',
    title: '某热门综艺录制现场突发事故，节目组紧急暂停拍摄',
    summary: '据现场观众爆料，某卫视王牌综艺节目昨日录制过程中出现舞台设备故障，导致一名嘉宾轻微受伤。节目组已暂停当日录制并启动安全排查。',
    content: '<p>据现场观众向本网爆料，某卫视王牌综艺节目在昨日的录制过程中突发舞台设备故障事故，导致一名参与录制的嘉宾轻微受伤。事故发生后，节目组立即暂停了当日所有的录制计划，并启动安全排查程序。</p><p>据目击者描述，事故发生在节目第三个游戏环节，当时舞台上方的一个道具装置突然松动脱落，擦碰到了一名嘉宾的手臂。现场工作人员迅速上前处理，医疗团队也在第一时间对受伤嘉宾进行了检查和处理。</p><p>节目组随后发表声明，向受伤嘉宾及所有参与录制的艺人、观众表示歉意，并承诺将全面检修所有舞台设备，确保不再发生类似事故。该节目的后续录制时间将另行通知。</p><p>此次事故也引发了行业对综艺节目录制安全问题的广泛关注。有业内人士指出，随着综艺节目竞争日益激烈，部分节目组为追求视觉效果，在舞台设计和道具使用上存在安全隐患，亟需行业规范和监管加强。</p>',
    category: 'yule-quan',
    categoryName: '娱乐圈',
    tags: ['综艺名场面', '热搜第一'],
    imageSeq: 'article-05',
    authorName: '综艺前线记者',
    authorAvatar: '',
    publishDate: '2026-07-05',
    viewCount: 7654300,
    commentCount: 54320,
    isHot: true,
    isTop: false,
    heatIndex: 5210360,
    readTime: 5,
  },
  {
    slug: 'nvxing-gongzuoshi-shengming',
    title: '某女星工作室发布严正声明：将对造谣者追究法律责任',
    summary: '针对近期网络上关于某女星的不实传言，其工作室今日通过官方微博发布严正声明，否认全部不实信息，并宣布已委托律师事务所取证维权。',
    content: '<p>针对近期网络上关于某知名女星的不实传言，其工作室于今日通过官方社交媒体平台发布了严正声明，表示所有相关传言均为恶意编造，工作室已经委托律师事务所进行全面取证，并将对造谣者依法追究法律责任。</p><p>声明中指出，近一周来，网络上出现了大量针对该女星的不实信息，涉及个人生活、职业发展和商业合作等多个方面。这些信息不仅严重损害了艺人的名誉权，也对其正常工作和生活造成了实质性的负面影响。</p><p>律师事务所方面透露，目前已经完成了初步的证据固定工作，锁定了多个首发造谣账号和恶意传播者。律师表示，根据相关法律规定，造谣传谣者可能面临民事赔偿甚至刑事责任。</p><p>该女星的粉丝后援会也发起了"不信谣不传谣"的倡议活动，呼吁网友理性看待网络信息，不要成为谣言的传播者。截至目前，多个首发谣言账号已经被平台封禁处理。</p>',
    category: 'wanghong-baoliao',
    categoryName: '网红爆料',
    tags: ['维权风波', '律师函警告'],
    imageSeq: 'article-06',
    authorName: '吃瓜编辑组',
    authorAvatar: '',
    publishDate: '2026-07-05',
    viewCount: 5987456,
    commentCount: 45670,
    isHot: false,
    isTop: false,
    heatIndex: 5987456,
    readTime: 6,
  },
  {
    slug: 'pinpai-daiyanren-genghuan',
    title: '国际奢侈品牌突然更换亚太区代言人，背后原因引发猜测',
    summary: '某国际知名奢侈品牌今日凌晨官宣更换亚太区品牌代言人，原代言人合约提前终止。业内人士分析可能与近期代言人个人形象危机有关。',
    content: '<p>某国际知名奢侈品牌今日凌晨通过官方渠道突然宣布更换亚太区品牌代言人，原代言人的合约被提前终止。这一突如其来的消息立刻在时尚圈和娱乐圈引发轩然大波，各方纷纷猜测背后的真实原因。</p><p>据悉，原代言人与该品牌的合作始于两年前，合约原定还有一年到期。品牌方在声明中仅以"战略调整"为由解释此次更换，但业内人士普遍认为，这与近期原代言人陷入的个人形象危机密切相关。</p><p>新晋代言人为一位近期人气急升的新生代艺人，其在社交媒体上的正面形象和年轻粉丝群体被认为是品牌选择的关键因素。品牌方表示，新的合作将更加注重"真实、多元、可持续"的品牌理念。</p><p>这一事件再次证明，在当前的舆论环境下，品牌方对代言人的风险管控意识显著增强。多位娱乐营销专家指出，品牌方在选择代言人时会更加审慎，"塌房"风险的评估已成为代言合作中的重要考量因素。</p>',
    category: 'chigua-qianxian',
    categoryName: '吃瓜前线',
    tags: ['品牌解约', '顶流塌房'],
    imageSeq: 'article-07',
    authorName: '时尚线记者',
    authorAvatar: '',
    publishDate: '2026-07-04',
    viewCount: 4876500,
    commentCount: 32100,
    isHot: false,
    isTop: false,
    heatIndex: 4876500,
    readTime: 5,
  },
  {
    slug: 'xinju-lutou-puguang',
    title: '知名演员新剧路透照曝光，造型突破引发网友热议',
    summary: '某实力派演员最新古装剧路透照今日流出，颠覆性的造型让网友直呼"认不出"。该剧预计将于年底登陆各大平台，目前正在横店紧张拍摄中。',
    content: '<p>某实力派演员最新古装剧的路透照片今日在社交平台上大量流出，其颠覆性的造型让网友直呼"认不出"。这组路透照中，该演员一改往日儒雅形象，以粗犷硬汉造型亮相，蓄须束发、战甲披身，完全打破了观众对其的固有印象。</p><p>该剧为一部大型古装战争题材作品，投资规模据称超过五亿元，由国内顶级制作团队打造。该演员在剧中饰演一位从底层小兵成长为一代名将的传奇人物，角色跨度极大，对演技要求极高。</p><p>路透照曝光后，网友反应热烈。不少网友表示"期待值拉满"，称赞该演员的敬业精神和敢于突破的勇气。也有部分原著粉丝对造型提出了不同意见，认为与原著描述存在一定差异。</p><p>据悉，该剧目前正在横店影视城紧张拍摄中，预计将于年底杀青，明年暑期档登陆各大卫视和视频平台。剧组方面对路透问题表示遗憾，并呼吁观众和媒体尊重剧组的创作过程，不要过度传播路透内容。</p>',
    category: 'yule-quan',
    categoryName: '娱乐圈',
    tags: ['综艺名场面', '热搜第一'],
    imageSeq: 'article-08',
    authorName: '剧组探班小分队',
    authorAvatar: '',
    publishDate: '2026-07-04',
    viewCount: 4321890,
    commentCount: 28900,
    isHot: false,
    isTop: false,
    heatIndex: 4321890,
    readTime: 4,
  },
  {
    slug: 'heiren-gongzuoshi-neimu',
    title: '独家揭秘：某MCN机构内部管理混乱，多位签约网红集体解约',
    summary: '据内部人士爆料，某头部MCN机构因长期拖欠分成款项、强制要求旗下网红接低质广告，导致多位百万粉丝级网红集体提出解约，行业震动。',
    content: '<p>据多位内部知情人士向本网独家爆料，某头部MCN机构内部管理存在严重问题，长期拖欠旗下签约网红的分成款项，并强制要求网红接低质量广告合作，导致多位百万粉丝级网红集体提出解约申请，引发行业震动。</p><p>一位不愿透露姓名的签约网红向记者表示，该机构拖欠其分成款项已超过三个月，累计金额高达数百万。"每次问财务，都说在走流程，但永远走不完。"此外，该机构还被指控强制捆绑签约，限制网红与其他品牌直接合作的自由。</p><p>据悉，此次集体解约的网红涵盖了美妆、美食、搞笑等多个垂直领域，总粉丝量超过五千万。如果这些网红全部成功解约，该MCN机构将面临严重的人才流失和商业损失。</p><p>目前，部分网红已经委托律师介入处理，不排除将通过法律途径维护自身权益。此事也引发了行业对MCN机构规范化管理的讨论，多个行业协会表示将推动制定更加完善的行业标准和合同范本。</p>',
    category: 'heiliaojiemi',
    categoryName: '黑料揭秘',
    tags: ['黑料今日', '网红爆料'],
    imageSeq: 'article-09',
    authorName: '深度调查组',
    authorAvatar: '',
    publishDate: '2026-07-03',
    viewCount: 3987600,
    commentCount: 45600,
    isHot: false,
    isTop: false,
    heatIndex: 3987600,
    readTime: 9,
  },
  {
    slug: 'chigua-qunzhong-rewu',
    title: '今日吃瓜指南：本周最值得关注的热点事件大盘点',
    summary: '本周吃瓜前线战况激烈，从顶流塌房到带货翻车，从恋情曝光到品牌解约，小编为大家整理了本周最劲爆的十大热点事件，一篇看完本周所有大瓜。',
    content: '<p>本周的吃瓜前线可谓战况激烈、好戏连台！从顶流深夜发文到带货主播现场翻车，从恋情曝光到品牌紧急解约，小编为您精心整理了本周最值得关注的十大热点事件，保证一篇看完本周所有大瓜。</p><p><strong>TOP 1：顶流深夜发文回应争议</strong>——某顶流艺人凌晨发布两千字长文，正面回应多项指控，宣布启动法律程序，话题阅读量突破三亿。</p><p><strong>TOP 2：带货主播直播翻车</strong>——三千万粉丝级主播在直播中产品功效遭实锤质疑，品牌方连夜道歉，消费者维权群已建立。</p><p><strong>TOP 3：当红小生恋情曝光</strong>——与圈外白富美秘密交往超一年，粉丝直呼"房子塌了"，目前当事人尚未回应。</p><p>此外，综艺录制事故、女星维权声明、奢侈品牌换代言人、新剧路透曝光、MCN机构内幕等一系列热点事件也持续发酵。吃瓜群众纷纷表示："这一周的瓜，够吃一个月了！"</p>',
    category: 'chigua-qianxian',
    categoryName: '吃瓜前线',
    tags: ['吃瓜一线', '热点聚焦'],
    imageSeq: 'article-10',
    authorName: '吃瓜编辑组',
    authorAvatar: '',
    publishDate: '2026-07-07',
    viewCount: 3542100,
    commentCount: 21450,
    isHot: false,
    isTop: false,
    heatIndex: 3542100,
    readTime: 10,
  },
  {
    slug: 'wanghong-zhibojian-zhengyi',
    title: '网红直播间争议言论持续发酵，多家品牌紧急切割',
    summary: '继某网红在直播间发表争议言论后，截至目前已有超过五家合作品牌宣布终止合作。该网红粉丝数量一夜之间暴跌百万，评论区彻底沦陷。',
    content: '<p>继某网红在直播间发表争议言论后，事态持续升级。截至目前，已有超过五家合作品牌通过官方渠道宣布终止与该网红的全部合作。该网红的社交媒体粉丝数量在一夜之间暴跌超过百万，评论区彻底沦陷。</p><p>事件起因于该网红在上周的直播中，对某社会热点事件发表了被认为不当的评论。虽然其在次日发布了道歉视频，但网友们并不买账，认为其道歉态度敷衍、避重就轻。随后，网友开始自发抵制其代言的产品。</p><p>品牌方反应迅速。第一个宣布解约的是一家国际美妆品牌，随后多家食品、服饰品牌跟进。业内人士分析，在当前舆论环境下，品牌方对代言人的社会言论极为敏感，一旦出现争议，"割席"速度之快前所未有。</p><p>该网红目前的商业价值已遭到严重打击，据估算，此次事件造成的直接经济损失可能超过千万元。这一案例也给所有依赖个人IP的网红敲响了警钟：流量越大，责任越大，一言一行都需谨慎。</p>',
    category: 'wanghong-baoliao',
    categoryName: '网红爆料',
    tags: ['直播争议', '品牌解约', '网红爆料'],
    imageSeq: 'article-11',
    authorName: '一线记者小王',
    authorAvatar: '',
    publishDate: '2026-07-03',
    viewCount: 6543200,
    commentCount: 54320,
    isHot: false,
    isTop: false,
    heatIndex: 6543200,
    readTime: 7,
  },
  {
    slug: 'pp-liao-shichang-fenxi',
    title: 'PP料市场深度分析：下半年行情展望与投资策略建议',
    summary: '随着下游需求逐步回暖，PP料市场迎来新的发展机遇。本文从供需基本面、成本端和宏观政策三个维度，深度剖析PP料下半年行情走势。',
    content: '<p>随着2026年进入下半年，PP料市场迎来了新的发展机遇和挑战。本文将从供需基本面、成本端和宏观政策三个维度，深度剖析PP料下半年的行情走势，为业内人士提供参考。</p><p><strong>供需基本面：</strong>下半年国内PP装置检修计划较为集中，预计将影响约80万吨产能。与此同时，下游塑编、注塑、薄膜等行业进入传统旺季，需求端有望环比改善。总体来看，下半年供应偏紧的格局或将延续。</p><p><strong>成本端分析：</strong>国际原油价格在近期维持震荡偏强走势，丙烯单体价格也处于相对高位，这为PP料价格提供了有力的成本支撑。不过需警惕全球经济增速放缓可能带来的原油需求下降风险。</p><p><strong>投资策略建议：</strong>综合以上因素，我们建议下游企业采取"逢低适量补库、避免追高"的策略。贸易商可关注阶段性套利机会。整体而言，下半年PP料价格大概率将维持宽幅震荡格局，运行区间预计在8200-9200元/吨。</p>',
    category: 'pp-liao',
    categoryName: 'PP料专区',
    tags: ['PP料今日最新价格'],
    imageSeq: 'article-12',
    authorName: '行情分析师老张',
    authorAvatar: '',
    publishDate: '2026-07-02',
    viewCount: 2876500,
    commentCount: 8760,
    isHot: false,
    isTop: false,
    heatIndex: 2876500,
    readTime: 8,
  },
];

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.category === slug);
}

export function getHotArticles(limit: number = 6): Article[] {
  return [...articles].sort((a, b) => b.heatIndex - a.heatIndex).slice(0, limit);
}

export function getLatestArticles(limit: number = 8): Article[] {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, limit);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getRelatedArticles(slug: string, limit: number = 4): Article[] {
  const article = getArticleBySlug(slug);
  if (!article) return [];
  return articles.filter((a) => a.category === article.category && a.slug !== slug).slice(0, limit);
}